import { createStore } from 'vuex';
import api from '../plugins/axios';
import { isTokenExpired } from '../plugins/token';
import document from './modules/document';

// start logged out when the stored refresh token is already dead
const storedRefresh = localStorage.getItem('refresh_token') || '';
const sessionAlive = !isTokenExpired(storedRefresh);
if (!sessionAlive) {
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('roles');
}

export default createStore({
  state: {
    accessToken: localStorage.getItem('access_token') || '',
    refreshToken: localStorage.getItem('refresh_token') || '',
    isAuthenticated: !!localStorage.getItem('access_token'),
    roles: JSON.parse(localStorage.getItem('roles')) || [],
  },
  mutations: {
    setAuthTokens(state, tokens) {
      state.accessToken = tokens.access;
      state.refreshToken = tokens.refresh;
      state.isAuthenticated = true;
      localStorage.setItem('access_token', tokens.access);
      localStorage.setItem('refresh_token', tokens.refresh);
    },
    logout(state) {
      // clear after logout from localstorage
      state.accessToken = '';
      state.refreshToken = '';
      state.isAuthenticated = false;
      state.roles = [];
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('roles');
    },
    setRoles(state, roles) {
      state.roles = roles;
      localStorage.setItem('roles', JSON.stringify(roles));
    },
  },
  actions: {
    async login({ commit }, userData) {
      try {
        const response = await api.post('/api/token/', userData);
        commit('setAuthTokens', response.data);
      } catch (err) {
        throw new Error('Login failed');
      }
    },
    async requestPasswordReset({ commit }, { email }) {
      try {
        await api.post('/api/request-password-reset/', { email });
      } catch (error) {
        throw error;
      }
    },
    logout({ commit }) {
      commit('logout');
    },
    async fetchUserRoles({ commit, state }) {
      if (state.isAuthenticated) {
        try {
          const response = await api.get('/api/user/roles/');
          commit('setRoles', response.data.roles);
        } catch (error) {
          console.error('Failed to fetch user roles:', error);
        }
      }
    },
  },
  modules: {
    document,
  },
});
